<template>
  <Main>
    <v-container>
      <v-row justify="center">
        <v-col cols="12">
          <v-card class="pa-5">
            <strong>AAM - Add New Promotion</strong>
            <v-form ref="form" v-model="valid" lazy-validation>
              <v-autocomplete
                v-model="type"
                :items="typeList"
                item-value="TYPE"
                item-text="TYPE"
                label="Type"
                color="red darken-1"
                @change="onSelectType($event)"
                :rules="[v => !!(v && v.length) || 'Type is required']"
              ></v-autocomplete>
              <v-text-field
                v-model="title" 
                label="Title"
                color="red darken-1"
                @click="dialogTitle = true"
                :append-outer-icon="'mdi-magnify'"
                @click:append-outer="dialogTitle = true"
                 @input="reversedMessageTitle"
                readonly
              ></v-text-field>
              <v-text-field
                v-model="typeDesc"
                :rules="typeDescRules"
                label="Description"
                color="red darken1"
                required
              ></v-text-field>
              <v-text-field
                v-model="url"
                :rules="typeDescRules"
                label="URL"
                color="red darken1"
              ></v-text-field>
              <v-row>
              <v-col md="12" sm="12">
                <!-- {{ "CSV : " + this.JSON_FILE_UPLOAD }} -->
                <v-file-input
                  v-model="JSON_FILE_UPLOAD"
                  color="red darken-1"
                  counter
                  :label="sizeImage"
                  placeholder="Select your image"
                  prepend-icon="mdi-paperclip"
                  outlined
                  :show-size="1000"
                  accept="image/jpeg"
                  @change="onAddFiles($event)"
                >
                  <template v-slot:selection="{ index, text }">
                    <v-chip
                      v-if="index < 2"
                      color="deep-purple accent-4"
                      dark
                      label
                      small
                    >
                      {{ text }}
                    </v-chip>

                    <!-- <span
                      class="overline grey--text text--darken-3 mx-2"
                    >
                      +{{ files.length - 2 }} File(s)
                    </span> -->
                  </template>
                </v-file-input>
              </v-col>
            </v-row>
              <v-row>
                <!-- START DATE -->
                <v-col v-if="!isEdit" cols="6">
                  <v-menu
                    v-model="isShowStartDate"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="startDate"
                        label="Start Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-on="on"
                        color="red darken1"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="startDate"
                      @input="isShowStartDate = false"
                      color="red darken1"
                    ></v-date-picker>
                  </v-menu>
                </v-col>

                <!-- END DATE -->
                <v-col cols="6">
                  <v-menu
                    v-model="isShowEndDate"
                    :close-on-content-click="false"
                    :nudge-right="40"
                    transition="scale-transition"
                    offset-y
                    min-width="290px"
                  >
                    <template v-slot:activator="{ on }">
                      <v-text-field
                        v-model="endDate"
                        label="End Date"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-on="on"
                        color="red darken1"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="endDate"
                      @input="isShowEndDate = false"
                      color="red darken1"
                    >
                      <template>
                        <v-card-actions class="w-100 float-right">
                          <v-btn
                            small
                            flat
                            color="warning"
                            @click="
                              (endDate = new Date().toISOString().substr(0, 10)),
                                (isShowEndDate = false)
                            "
                            >Select Today</v-btn
                          >
                        </v-card-actions>
                      </template>
                    </v-date-picker>
                  </v-menu>
                </v-col>
              </v-row>

              <v-btn @click="confirmModal(submit)" color="warning" class="mr-4"
                >Submit</v-btn
              >
            </v-form>
          </v-card>

          <br />
          <v-card class="pa-5">
            <v-card-title>
              Promotion List
              <v-spacer></v-spacer>
              <v-text-field
                v-model="searchType"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
                color="red darken1"
              ></v-text-field>
            </v-card-title>
            <v-data-table
              :headers="dtHeaders"
              :items="dtItems"
              :search="searchType"
              :loading="dtLoading"
              loading-text="Fetching Data..."
            >
          
            <template v-slot:item.fileName="{ item }">
              <v-icon small class="mr-2" @click="previewItem(item)">mdi-eye</v-icon>
             </template>

              <template v-slot:item.delete="{ item }" >
                <v-icon small class="mr-2" @click="deleteData(item)"
                  >mdi-close</v-icon
                >
              </template>

              <template v-slot:item.DetailTitle="{ item }">
                    <v-icon
                      small
                      class="mr-2"
                      @click="DetailTitle(item)"
                    >
                      mdi-list-box-outline
                    </v-icon>
              </template>
            </v-data-table>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <!--dialog title new-->
    <template>
      <v-row justify="center">
        <v-dialog
          v-model="dialogTitle"
          scrollable
          max-width="500px"
        >
        <template>
          <v-card>
            <v-card-title>
              <v-text-field
                v-model="search"
                append-icon="mdi-magnify"
                label="Search"
                single-line
                hide-details
              ></v-text-field>
            </v-card-title>
            <v-data-table
              v-model="title"
              :headers="headersTitle"
              :items="arrTitle"
              :search="search"
              item-key="TITTLE_CODE"
              show-select
              class="elevation-1"
              disable-pagination
              hide-default-footer
            ></v-data-table>
          </v-card>
        </template>
        </v-dialog>
      </v-row>
    </template>

    <!-- SNACKBAR -->
    <v-snackbar v-model="isShowSnackbar" top>{{ snackbarText }}</v-snackbar>
    <!-- LOADING OVERLAY -->
    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <!-- Start Validation Submit -->
    <v-dialog v-model="isOpenModalConfirm" max-width="500px">
      <v-card>
        <v-card-title class="headline">Are you Sure to Continue ?</v-card-title>

        <v-card-text
          >It will save input data to database. Please give confirmation before you
          continue.</v-card-text
        >

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn color="red darken-1" text @click="isOpenModalConfirm = false"
            >Cancel</v-btn
          >

          <v-btn color="green darken-1" text @click="methodAction">Submit</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- End Validation Submit -->
     <!-- MODAL -->
     <v-row justify="center">
      <v-dialog
        v-if="isShowPreview"
        v-model="isShowPreview"      
        fullscreen
        hide-overlay
        transition="dialog-bottom-transition"
      >
        <v-card>
          <v-toolbar dark color="warning">
            <v-btn icon dark @click="isShowPreview = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
            <v-toolbar-title>Preview Promotion Image</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn dark text @click="isShowPreview = false">Close</v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-container fluid>
           <img v-bind:src="`${imageList}`" alt="Promotion Banner" />
          </v-container>
        </v-card>
      </v-dialog>
    </v-row>
    <!-- END MODAL -->

    <!--dialog Title-->
    <template>
      <v-row justify="center">
        <v-dialog
          v-model="dialogTitleView"
          scrollable
          max-width="500px"
        >
        <template>
          <v-card>
            <v-data-table
              v-model="titlepa"
              :headers="dtHeaderTitle"
              :items="dtItemsTitle"
              item-key="TITTLE_ID"
              :loading="dtLoading"
              class="elevation-1"
            ></v-data-table>
          </v-card>
        </template>
        </v-dialog>
      </v-row>
    </template>
  </Main>
</template>

    

<script>
import Main from "@/Main.vue";
import moment from "moment";
import {S3_CONNECTION} from "../../lib/config";
const s3 = new AWS.S3(S3_CONNECTION);

const dtHeaders = [
  { text: "Type", value: "promoType" },
  // { text: "Title", value: "promoTitle" },
  {
    text: "Title",
    value: "DetailTitle",
    align: "center",
  },
  { text: "Description", value: "promoDesc" },
  { text: "Url", value: "url" },
  { text: "Image", value: "fileName" },
  { text: "Start Date", value: "startDate" },
  { text: "End Date", value: "endDate" },
  { text: "Delete", value: "delete", sortable: false },
];

const dtHeaderTitle = [
  {
    text: "TITTLE DESC",
    value: "TITTLE_DESC",
  }
];

export default {
  components: {
    Main,
  },
  data() {
    return {
      methodAction: "",
      isOpenModalConfirm: false,
      isEdit: false,
      type: "",
      typeRules: [(v) => !!v || "Type is required"],
      typeDesc: "",
      typeDescRules: [(v) => !!v || "Type description is required"],
      startDate: moment().startOf("month").format("YYYY-MM-DD"),
      isShowStartDate: false,
      endDate: moment("4001-12-31").endOf("month").format("YYYY-MM-DD"),
      isShowEndDate: false,
      isLoading: false,
      snackbarText: "",
      isShowSnackbar: false,
      valid: true,
      dtHeaders,
      searchType: "",
      dtItems: [],
      dtLoading: false,
      typeList: [
        {
          TYPE: "IKLAN",
        },
        {
          TYPE: "BANNER",
        },
      ],
      JSON_FILE_UPLOAD: [],
      image: '',
      url:'',
      isShowPreview: false,
      imageList:'',
      sizeImage:'Input image',
      dialogTitleView: false,
      dialogTitle: false,
      title: "",
      headersTitle: [
          { text: "TITTLE CODE", value: "TITTLE_CODE" }
        ],
      dtHeaderTitle,
      dtItemsTitle: []
    }
  },
  computed: {
    reversedMessageTitle: function () {
      if(this.title.length>0){
        let items = this.title;
        let arrItem=[];
        items.map(function(item) {
          arrItem.push(item.TITTLE_CODE);
        });
        this.title = arrItem.toString();
        return arrItem.toString();
      }
    },
  },
  mounted() {
    this.populateDataTable();
    this.getTitle();
  },
  watch: {
    
  },
  methods: {
    confirmModal: function (method) {
      this.isOpenModalConfirm = true;
      this.methodAction = method;
    },
    submit() {
      const isValid = this.$refs.form.validate();
      if (isValid == false) return;
      this.isLoading = true;
      this.isOpenModalConfirm = false;
      const userData = JSON.parse(localStorage.getItem("userData"));
      let data = {
        typeCode: this.type,
        title: this.title,
        typeDesc: this.typeDesc,
        url: this.url,
        image: this.image,
        startDate: this.startDate,
        endDate: this.endDate,
        userIdUpdate: userData.USER_ID,
        lastUpdate: moment().format("YYYY-MM-DD HH:mm:ss"),
      };

      this.$http
        .post("/setting/insertSlide", data, {
          headers: {
            "api-key": this.$apiKey
          }
        })
        .then((res) => {
          if (!res.data.success || res.data.success == undefined) {
            console.log(res);
          }
          if (res.data.success) {
            this.isLoading = false;
            this.showSnackbar("Data saved successfully");
            this.type = "";
            this.typeDesc = "";
            this.url = "";
            this.image = "";
            this.$refs.form.resetValidation();
            this.populateDataTable();
          } else {
            this.isLoading = false;
            this.showSnackbar(res.data.data);
            this.showSnackbar("Data failed to save");
          }
        })
        .catch((err) => {
          this.isLoading = false;
          this.showSnackbar(err.toString());
        });
    },
    deleteData(item) {
        if(confirm("Do you really want to delete?")){
          let data = {
            ID: item.ID
          };

            this.$http
            .post("/setting/deleteslide", data, {
              headers: {
                "api-key": this.$apiKey
              }
            })
            .then((res) => {
                this.isLoading = false;
                this.showSnackbar("Data deleted successfully");
                this.populateDataTable();
            })
            .catch((err) => {
              this.isLoading = false;
              this.showSnackbar(err.toString());
            });
        }
    },
    async loadImage(val){
                const params = {
                    Bucket: S3_CONNECTION.accessKeyId,
                    Key: val.fileName
                }
                const imageSrc = await s3.getObject(params).promise();
                let imageSrcTst = `data:image/jpeg;base64,${imageSrc.Body.toString('base64')}`;
                return imageSrcTst
    },
   async previewItem(item) {
      this.$http
        .post("/setting/selectimagebyid", item, {
          headers: {
            "api-key": this.$apiKey,
          },
        })
        .then(async (res) => {
          this.isLoading = true;
          if (res.data != null) {
            this.imageList = res.data.data
    
            this.isLoading = false;
            this.isShowPreview = true;
          }
        })
        .catch((err) => {
          this.isLoading = false;
        });
    },
    onAddFiles(e) {
      const file = this.JSON_FILE_UPLOAD;     
      const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = evt => {
          let img = new Image();
          img.onload = () => {
            this.uploadImage(reader.result,  img.width, img.height)
          }
          img.src = evt.target.result;
        }

        reader.onerror = evt => {
          console.error(evt);
        }
    },
    uploadImage(valBase64, width, height){
      let fixWidth = 0;
      let fixHeight = 0;
      console.log('width ', width)
      console.log('height ', height)
      if(this.type === 'IKLAN'){
        fixWidth = 1080;
        fixHeight = 1350;
      }else{
         fixWidth = 1200;
         fixHeight = 420;
      }
      if(fixWidth == width && fixHeight == height){              
                this.image=valBase64;
      }else{  
               this.JSON_FILE_UPLOAD=[];
               this.showSnackbar("Image size should be " + fixWidth + " wide, " + fixHeight + " height.");
      }
    },
    showSnackbar(text) {
      this.snackbarText = text;
      this.isShowSnackbar = true;
    },
    populateDataTable() {
      this.dtLoading = true;
      this.$http
        .get("/setting/selectslide", {
          headers: {
            "api-key": this.$apiKey
          }
        })
        .then(async (res) => {
          
          this.dtLoading = false;
          if (!res.data.success || res.data.success == undefined) {
            console.log(res);
          }
          let { data } = res.data;
          this.dtItems = data.map((obj) => {        
            return {
              ID : obj.ID,
              fileName: obj.FILE_NAME,
              promoDesc: obj.PROMOTION_DESC.substring(0,50) + ' ...',
              promoType: obj.PROMOTION_TYPE,
              promoTitle: obj.promoTitle,
              url: obj.URL.substring(0,50) + ' ...',
              isActive: obj.IS_ACTIVE,
              startDate: moment(obj.START_DATE).format("YYYY-MM-DD"),
              endDate: moment(obj.END_DATE).format("YYYY-MM-DD"),
            };            
          });
          console.log('dtItems.promoType ', this.dtItems.promoType)
          // this.dtItemsTitle = dtItems.promoType.map((obj) => {  
            
          //   console.log('obj.promoTitle ', obj.promoTitle) 
          //   });

          //TITTLE_ID, TITTLE_DESC

        })
        .catch((err) => {
          this.dtLoading = false;
        });
    },
    onSelectType(e) { 
      if(this.type === 'IKLAN'){
        this.sizeImage="Size image width=1080px, height=1350px";
      }else{
        this.sizeImage="Size image width=1200px, height=420px";
      }
    },
    getTitle() {
            let data = {
              TypeEmp : "test"
            };
            this.isLoading = true;
            this.$http
                .post("/setting/getTitleAll", data, {
                  headers: {
                    "api-key": this.$apiKey
                  }
                })
                .then(res => {
                    if (res.data.success) {
                        this.arrTitle = res.data.data.resultTitle;
                        this.isLoading = false;
                        this.showSnackbar("Get Data Success...");
                    } else {
                        this.isLoading = false;
                        this.isShowData = false;
                        this.showSnackbar(res.data.message);
                    }
                })
                .catch(err => {
                    this.isLoading = false;
                    this.isShowData = false;
                    this.showSnackbar(err.toString());
                });
        },
    DetailTitle(item){
      this.getTitleView(item.promoTitle);      
    },
    getTitleView(promoTitle){      
      this.dtLoading = true;
      this.dialogTitleView=true;      
      const arrTittle = promoTitle.split(",");
      let dataTittle = [];
      for (let i = 0; i < arrTittle.length; i++) {  
        dataTittle.push({
          "TITTLE_ID" : i,
          "TITTLE_DESC" : arrTittle[i]
        })
      }
      this.dtItemsTitle=dataTittle;
      this.dtLoading = false;      
    },
  },
};
</script>
